export default __webpack_public_path__ + "static/media/profile.70d0c848.jpg";